import { useParams } from 'react-router-dom'
import { SweepstakesDetailsHeader } from '../SweepstakesDetailsPage/SweepstakeDetailsHeader'
import { useGetSweepstakeByIdWithParticipatingLocations } from 'hooks/api/useGetSweepstakeByIdWithParticipatingLocations'
import { ActivityIndicator } from 'components/Shared/ActivityIndicator'
import { isNil } from 'lodash'
import { Box, Typography } from '@mui/material'
import { formatDateTime } from 'utils/util'
import { DataTable } from 'components/Shared/DataTable'
import { type GridColDef } from '@mui/x-data-grid'
import { type components } from 'src/api/playerPayback/api'
import { useLayout } from 'hooks/useLayout'
import { useGetContestActivityLogBySweepstakeId } from 'hooks/api/Contests/useGetContestActivityLogBySweepstakeId'

const getColumns = (
  isMobile: boolean
): Array<GridColDef<components['schemas']['FullContestsActivityLogDTO']>> => [
  {
    field: 'description',
    headerName: 'Description',
    width: 1000,
  },
  {
    field: 'createdBy',
    headerName: 'Updated By',
    valueGetter: (params) => {
      const createdBy = params.row.createdBy
      return createdBy === 'JJVentures.PlayerPAYBACK.WebApi' ? '' : createdBy
    },
    width: 300,
  },
  {
    field: 'createdOn',
    headerName: 'Timestamp',
    valueFormatter: (params: { value: string }) => {
      const date = formatDateTime(params.value, 'MM-dd-yyyy p')
      return isMobile ? `Date: ${String(date)}` : date
    },
    width: 240,
  },
]

export const SweepstakeActivityLogPage = () => {
  const { id: idParam } = useParams()
  const { isMobile } = useLayout()
  const sweepstakeId = Number(idParam)
  const sweepstakeQuery = useGetSweepstakeByIdWithParticipatingLocations(
    Number(sweepstakeId)
  )
  const contestActivityLogQuery = useGetContestActivityLogBySweepstakeId(
    Number(sweepstakeId)
  )

  if (sweepstakeQuery.isError || isNil(sweepstakeQuery.data)) {
    return <Box>An error occurred fetching the sweepstake.</Box>
  }

  return (
    <SweepstakesDetailsHeader
      sweepstake={sweepstakeQuery.data}
      currentTab={`/Contests/Sweepstakes/${Number(sweepstakeQuery.data?.id)}/ActivityLog`}
    >
      {contestActivityLogQuery.isPending ? (
        <ActivityIndicator marginTop={8} />
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            rowGap: { xs: '8px', sm: '24px' },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              width: '100%',
              justifyContent: { xs: 'start', sm: 'space-between' },
              alignItems: { xs: 'start', sm: 'center' },
              rowGap: '8px',
            }}
          >
            <Box>
              <Typography variant={'h2'}>Activity Log</Typography>
            </Box>
          </Box>
          {contestActivityLogQuery.isPending ? (
            <ActivityIndicator size="fullPage" />
          ) : (
            <DataTable
              columns={getColumns(isMobile)}
              rows={contestActivityLogQuery.data ?? []}
              noDataMessage="No activity log data to date."
              sortFieldName="createdOn"
              sort="desc"
            />
          )}
        </Box>
      )}
    </SweepstakesDetailsHeader>
  )
}
